import { logger } from "appworks/utils/logger";
import { gamevyForceData } from "gamevy/components/gamevy-force-data";
import { DebugTab } from "slotworks/debug/menu/tabs/debug-tab";

export class GamevyForceResultTab extends DebugTab {

    public render(root: HTMLElement, hide: Function) {
        const nValue = document.createElement("textarea");

        nValue.style.fontSize = "1.5vw";
        nValue.style.borderRadius = "10px 10px 0 0";
        nValue.style.resize = "none";
        nValue.style.width = "calc(100% - 20pt)";
        nValue.style.height = "10vmax";
        nValue.style.padding = "10pt";
        nValue.style.backgroundColor = "#ffffff";
        nValue.placeholder = "ex: [ 20, 6, 0, 2, 0, 6 ]";

        root.appendChild(nValue);

        const btn = document.createElement("button");

        btn.style.fontSize = "2vw";
        btn.style.borderRadius = "0 0 10px 10px";
        btn.style.width = "100%";
        btn.style.height = "5vmax";
        btn.style.backgroundColor = "#ffffff";
        btn.innerText = "Set Spin Force";

        (window as any).setGamevyForce = (n: number[]) => {
            gamevyForceData.setForceData({ n });
        };

        (window as any).setGamevyForcePreset = (id: string) => {
            this.resultList.force(id).execute();
        };

        btn.onclick = () => {
            try {
                const n: number[] = JSON.parse(nValue.value);
                gamevyForceData.setForceData({ n });
            } catch (e) {
                logger.error(e);
                gamevyForceData.setForceData({ n: [] });
            }

            hide();
        };

        root.appendChild(btn);

        this.resultList.getList().then((list: string[]) => {
            if (list.length > 0) {
                this.addSeparator(root);

                const header = document.createElement("h1");

                header.style.fontSize = "2vw";
                header.style.width = "76vw";
                header.style.color = "white";
                header.style.textAlign = "center";
                header.innerText = "Preset Forces";

                root.appendChild(header);
            }

            list.forEach((force) => {
                this.addResultButton(root, hide, force);
            });
        });
    }
}
